<ng-container *ngIf="vm$ | async as vm">
	<div class="flex flex-col px-1 h-full">
		<div class="text-2xl mb-8 mt-4 font-bold">Personal Information</div>
		<form
			class="text-sm flex-1 flex flex-col justify-between"
			[formGroup]="authForm"
			(ngSubmit)="onSubmitForm()"
			novalidate
		>
			<div class="flex flex-col text-sm">
				<app-input
					class="mt-3"
					appTextOnly
					label="First Name"
					[ngModel]="vm.formData?.firstName"
					(onFocus)="updateLandscapePosition(landscapePositions.FIRST)"
					(debounce)="onNameEnter()"
					formControlName="{{ USER_INFORMATION.FIRST_NAME }}"
					placeholder="Sam"
					[disabled]="authLoading"
					[required]="true"
				></app-input>

				<app-input
					class="mt-3"
					appTextOnly
					label="Last Name"
					[ngModel]="vm.formData?.lastName"
					(onFocus)="updateLandscapePosition(landscapePositions.SECOND)"
					(debounce)="onNameEnter()"
					formControlName="{{ USER_INFORMATION.LAST_NAME }}"
					placeholder="Johnson"
					[disabled]="authLoading"
					[required]="true"
				></app-input>

				<div class="mt-3 flex gap-6 items-end max-w-56">
					<app-input
						label="Preferred Initials"
						[ngModel]="vm.formData?.initials"
						(onFocus)="updateLandscapePosition(landscapePositions.THIRD)"
						formControlName="{{ USER_INFORMATION.INITIALS }}"
						placeholder="SJ"
						appTextOnly
						[disabled]="authLoading"
						[required]="true"
					></app-input>
					<atomic-name-badge
						[initials]="initials?.value"
						[bold]="true"
						[size]="'small'"
					></atomic-name-badge>
				</div>

				<app-dropdown
					class="mt-3"
					[readonly]="true"
					(onSelect)="onSelectRole($event)"
					formControlName="{{ USER_INFORMATION.ROLE }}"
					[inputClasses]="role.value ? 'capitalize' : ''"
					placeholder="Select a role"
					[ngModel]="vm.formData?.role"
					[disabled]="authLoading"
					(onFocus)="updateLandscapePosition(landscapePositions.FOURTH)"
					label="Business Role"
					[itemGroups]="[{ items: roleOptions }]"
					[submitted]="vm.submitted"
					[required]="true"
				>
				</app-dropdown>

				<app-input
					*ngIf="!onlyProfile"
					class="mt-3"
					type="tel"
					[ngModel]="vm.formData?.phoneNumber"
					label="Phone Number"
					labelEndType="optional"
					(onFocus)="updateLandscapePosition(landscapePositions.FIFTH)"
					formControlName="{{ USER_INFORMATION.PHONE_NUMBER }}"
					placeholder="(___) ___-____"
					[disabled]="authLoading"
				></app-input>
			</div>

			<div class="flex justify-end items-end">
				<ui-button
					type="submit"
					class="self-end"
					btn="primary"
					[loading]="authLoading"
					preset="HIGH_EMPHASIS"
					size="md"
					[label]="onlyProfile ? 'Explore Closer' : 'Continue'"
				></ui-button>
			</div>
		</form>
	</div>
</ng-container>
